import { childrenBusinessPageBreadcrumbs } from '@/pages/Business/config';
import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { NavigateFunction } from 'react-router-dom';

export const batchCheckpointsBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [...childrenBusinessPageBreadcrumbs(navigate)];
